import { createApp } from 'vue'
import { createHead } from '@unhead/vue/client'
import App from '@/App.vue'
import router from '@/router'
import pinia from '@/stores'
import 'virtual:uno.css'
import '@/styles/app.less'
import '@/styles/var.less'
import '@/styles/theme-light.less'
import '@/styles/theme-whitegray.less'
import { i18n } from '@/utils/i18n'
import VueScrollTo from 'vue-scrollto'
import { STORAGE_TOKEN_KEY, STORAGE_USER_INFO_KEY } from '@/stores/mutation-type'
import { closeWebSocket } from '@/utils/websocketService'

// Vant 桌面端适配
import '@vant/touch-emulator'
import 'vant/es/toast/style'
import 'vant/es/dialog/style'
import 'vant/es/notify/style'
import 'vant/es/image-preview/style'

const scrollOptions = {
  container: 'body', //滚动的容器
  duration: 500, //滚动时间
  easing: 'ease', //缓动类型
  offset: -50, // 滚动时应应用的偏移量。此选项接受回调函数
  force: true, // 是否应执行滚动
  cancelable: true, // 用户是否可以取消滚动
  onStart: false, // 滚动开始时的钩子函数
  onDone: false, // 滚动结束时候的钩子函数
  onCancel: false, // 用户取消滚动的钩子函数
  x: false, // 是否要在x轴上也滚动
  y: true, // 是否要在y轴上滚动
}

// 初始化 deferredPrompt
// window.deferredPrompt = null

// // 提前注册 beforeinstallprompt 事件监听器
// window.addEventListener('beforeinstallprompt', (e) => {
//   console.log('beforeinstallprompt event triggered')
//   e.preventDefault()
//   window.deferredPrompt = e // 保存事件对象
// })

// console.log('window.deferredPrompt0:', window.deferredPrompt)

const app = createApp(App)
const head = createHead()

// 移除全局属性注册
// app.config.globalProperties.$getImageUrlWithCDN_TEST = getImageUrlWithCDN_TEST
app.use(VueScrollTo, scrollOptions)
app.use(head)
app.use(router)
app.use(pinia)
app.use(i18n)
router.isReady().then(() => {
  // let baseUrl = ''
  // const href = location.href
  // baseUrl = 'https://api.tbjgames.com'
  // fetch(baseUrl + '/initConfig')
  //   .then((e) => {
  //     if (!e.ok) throw new Error('Network response was not ok')
  //     return e.json()
  //   })
  //   .then((e) => {
  //     localStorage.setItem('appid', e.data.appid)
  //     const currentTheme = 'light' //  e.data.theme ||
  //     localStorage.setItem('initConfig', JSON.stringify(e.data))
  //     localStorage.setItem('cdn_url', e.data.cdn_url)
  //     document.documentElement.setAttribute('data-theme', currentTheme)
  //     console.log('调用 setAttribute 函数...')
  //     setTimeout(() => {
  //       app.mount('#app') // 确保即使接口失败也能挂载应用
  //     }, 100)
  //   })
  //   .catch((error) => {
  //     console.error('Failed to fetch initConfig:', error)
  //     app.mount('#app') // 确保即使接口失败也能挂载应用
  //   })
  const currentTheme = 'light'
  document.documentElement.setAttribute('data-theme', currentTheme)
  app.mount('#app') // 确保即使接口失败也能挂载应用
})
